<mat-card style="height: 100%; border: 1px solid rgb(216, 217, 217)">
    <mat-card-header>
        <mat-card-title style="font-size: large">Rapid Result
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <hr />
        <h3>{{title}}</h3>
        <div *ngIf="approvalMessage">{{approvalMessage}}</div>
        <div>Credit Score: {{data.creditScore}}</div>
        <div *ngIf="mortgageBalance">Mortgage Balance: {{mortgageBalance}}</div>
        <div *ngIf="estimatedValue">Estimated Property Value: {{estimatedValue}}</div>
        <div *ngIf="ltv">LTV: {{ltv}}</div>
        <div *ngIf="rapidScoreStatus">Rapid Result: {{rapidScoreStatus}}</div>
        <div *ngIf="rapidStatus">Rapid Status: {{rapidStatus}}</div>
        <div *ngIf="rapidStage">Rapid Stage: {{rapidStage}}</div>
    </mat-card-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="onClose()">Close</button>
    </mat-dialog-actions>
</mat-card>